import React from 'react';
import { Box } from '@mui/material';
import LoadingSpinner from './LoadingSpinner';
import { useTranslation } from '../../hooks/useTranslation';

const PageLoader = ({
  message,
  type = 'logo',
  fullScreen = false
}) => {
  const { t } = useTranslation();
  const defaultMessage = message || t('common.loading');
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: fullScreen ? '100vh' : '400px',
        backgroundColor: fullScreen ? '#F8F9FA' : 'transparent',
        width: '100%'
      }}
    >
      <LoadingSpinner
        type={type}
        size="large"
        message={defaultMessage}
        showMessage={true}
      />
    </Box>
  );
};

export default PageLoader;